export default __webpack_public_path__ + "static/media/haffinity-pattern.5d396405.jpg";